import React, {Suspense, lazy} from 'react';
import {HeaderTop} from "./components/tpl/HeaderTop";
import {FooterBottom} from "./components/tpl/FooterBottom";
import {FixMenuBottom} from "./components/tpl/menu/FixMenuBottom";
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import {AdminAuthPage} from "./pages/admin/AdminAuthPage";
import {AdminPage} from "./pages/admin";
import {AdminTop} from "./components/tpl/AdminTop";
import {AdminEmailReplayPage} from "./pages/admin/AdminEmailReplayPage";
import QuizPage from "./pages/QuizPage";
import QuizReport from "./components/QuizReport";
import {AdminUserLogPage} from "./pages/admin/AdminUserLogPage";
import DopInfoPage from "./pages/DopInfoPage";
import LoyaltyPage from "./pages/LoyaltyPage";
import CatalogSearchPageByCategory from './pages/CatalogSearchPageByCategory';


const TestTable = lazy(  () => import('./pages/testTable/Test2'))
const MessagePage = lazy(  () => import('./pages/MessagePage'))
const PersonalPage = lazy(  () => import('./pages/personal'))
const AddTradePointPage = lazy(  () => import('./pages/personal/AddTradePointPage'))
const RegTradePointSuccessfulPage = lazy(  () => import('./pages/personal/RegTradePointSuccessfulPage'))
const AddUserPage = lazy(  () => import('./pages/personal/AddUserPage'))
const RegUserSuccessfulPage = lazy(  () => import('./pages/personal/RegUserSuccessfulPage'))
const UpdUserPage = lazy(  () => import('./pages/personal/UpdUserPage'))
const UpdUserSuccessfulPage = lazy(  () => import('./pages/personal/UpdUserSuccessfulPage'))
const LoginPage = lazy(  () => import('./pages/LoginPage'))
const RegAllPage = lazy(  () => import('./pages/RegAllPage'))
const RegSuccessfulPage = lazy(  () => import('./pages/RegSuccessfulPage'))
const ChangePage = lazy(  () => import('./pages/ChangePage'))
const ConfirmPage = lazy(  () => import('./pages/ConfirmPage'))
const BasketPage = lazy(  () => import('./pages/BasketPage'))
const OrderSuccess = lazy(  () => import('./pages/OrderSuccessl'))
const OrderPage = lazy(  () => import('./pages/OrderPage'))
const OrderDetail = lazy(  () => import('./pages/OrderDetail'))
const ReturnPage = lazy(  () => import('./pages/ReturnPage'))
const ReturnDetail = lazy(  () => import('./pages/ReturnDetail'))
const CommercialPage = lazy(  () => import('./pages/CommercialPage'))
const ClientPage = lazy(  () => import('./pages/ClientPage'))
const CatalogPage = lazy(  () => import('./pages/CatalogPage'))
const CatalogSearchPage = lazy(  () => import('./pages/CatalogSearchPage'))
const CardPage = lazy(  () => import('./pages/CardPage'))
const NotFoundPage = lazy(  () => import('./pages/NotFoundPage'))
const IndexPage = lazy(  () => import('./pages/IndexPage'))
const DopInfo = lazy(  () => import('./pages/DopInfo'))
const BrandPage = lazy(  () => import('./pages/BrandPage'))
const PrivacyPolicyPage = lazy(  () => import('./pages/PrivacyPolicyPage'))
const DeliveryPage = lazy(  () => import('./pages/DeliveryPage'))
const PaymentPage = lazy(  () => import('./pages/PaymentPage'))
const HowOrderPage = lazy(  () => import('./pages/HowOrderPage'))
const ReturnConditionsPage = lazy(  () => import('./pages/ReturnConditionsPage'))

export default class App extends React.Component {

    render() {

        return (
            <>
                <Router>
                    <AdminTop/>
                    <HeaderTop/>
                     <DopInfoPage/>
                    <Switch>
                        <Route exact path="/" children={ <Suspense fallback={<div>Загрузка....</div>} ><IndexPage/> </Suspense>}/>
                        <Route exact path="/dopInfo" children={ <Suspense fallback={<div>Загрузка....</div>} ><DopInfo/> </Suspense>}/>
                        <Route exact path="/test" children={<Suspense fallback={<div>Загрузка....</div>} ><TestTable/> </Suspense>}/>
                        <Route exact path="/message" children={ <Suspense fallback={<div>Загрузка....</div>} ><MessagePage/> </Suspense>}/>
                        <Route exact path="/personal" children={ <Suspense fallback={<div>Загрузка....</div>} ><PersonalPage/> </Suspense> }/>

                        <Route exact path="/personal/add-trade-point" children={ <Suspense fallback={<div>Загрузка....</div>} ><AddTradePointPage/> </Suspense> }/>


                        <Route exact path="/personal/add-trade-point-successful"
                               children={ <Suspense fallback={<div>Загрузка....</div>} ><RegTradePointSuccessfulPage/> </Suspense>}/>

                        <Route exact path="/personal/add-user" children={ <Suspense fallback={<div>Загрузка....</div>} ><AddUserPage/> </Suspense> }/>
                        <Route exact path="/personal/add-user-successful" children={ <Suspense fallback={<div>Загрузка....</div>} > <RegUserSuccessfulPage/> </Suspense>  }/>

                        <Route exact path="/personal/upd-user/:id" children={<Suspense fallback={<div>Загрузка....</div>} > <UpdUserPage/>  </Suspense> }/>
                        <Route exact path="/personal/upd-user-successful" children={ <Suspense fallback={<div>Загрузка....</div>} > <UpdUserSuccessfulPage/>  </Suspense> }/>

                        <Route exact path="/login" children={  <Suspense fallback={<div>Загрузка....</div>} > <LoginPage/>  </Suspense> }/>
                        <Route exact path="/reg-all" children={ <Suspense fallback={<div>Загрузка....</div>} > <RegAllPage/>  </Suspense> }/>
                        <Route exact path="/reg-all" children={ <Suspense fallback={<div>Загрузка....</div>} > <RegAllPage/>  </Suspense> }/>
                        <Route exact path="/privacy-policy" children={ <Suspense fallback={<div>Загрузка....</div>} > <PrivacyPolicyPage/>  </Suspense> }/>
                        <Route exact path="/reg-successful" children={  <Suspense fallback={<div>Загрузка....</div>} > <RegSuccessfulPage/>   </Suspense>}/>

                        <Route path="/change/:code" children={<Suspense fallback={<div>Загрузка....</div>} > <ChangePage/>  </Suspense>}/>
                        <Route path="/email/:code" children={  <Suspense fallback={<div>Загрузка....</div>} > <ConfirmPage/>  </Suspense>}/>

                        <Route exact path="/basket" children={  <Suspense fallback={<div>Загрузка....</div>} > <BasketPage/>  </Suspense>}/>
                        <Route exact path="/basket-successful" children={ <Suspense fallback={<div>Загрузка....</div>} > <OrderSuccess/>  </Suspense> }/>

                        <Route exact path="/order" children={ <Suspense fallback={<div>Загрузка....</div>} > <OrderPage/> </Suspense> }/>
                        <Route exact path="/order/:id" children={ <Suspense fallback={<div>Загрузка....</div>} > <OrderDetail/> </Suspense>  }/>

                        <Route exact path="/return" children={ <Suspense fallback={<div>Загрузка....</div>} > <ReturnPage/> </Suspense>}/>
                        <Route exact path="/return/:id" children={  <Suspense fallback={<div>Загрузка....</div>} > <ReturnDetail/></Suspense>}/>


                        <Route exact path="/commercial" children={<Suspense fallback={<div>Загрузка....</div>} > <CommercialPage/> </Suspense>}/>
                        <Route exact path="/commercial/:code" children={<Suspense fallback={<div>Загрузка....</div>} > <CommercialPage/> </Suspense>}/>

                        <Route exact path="/client" children={ <Suspense fallback={<div>Загрузка....</div>} > <ClientPage/></Suspense>}/>


                        <Route exact path="/catalog" children={ <Suspense fallback={<div>Загрузка....</div>} > <CatalogPage/></Suspense> }/>
                        <Route exact path="/catalog/search" children={ <Suspense fallback={<div>Загрузка....</div>} > <CatalogSearchPage/></Suspense>}/>
                        <Route exact path="/catalog/search_by_category" children={ <Suspense fallback={<div>Загрузка....</div>} > <CatalogSearchPageByCategory/></Suspense>}/>
                        <Route exact path="/catalog/filter/:filter" children={ <Suspense fallback={<div>Загрузка....</div>} > <CatalogPage/></Suspense> }/>
                        <Route exact path="/catalog/:code1" children={<Suspense fallback={<div>Загрузка....</div>} > <CatalogPage/></Suspense> }/>
                        <Route exact path="/catalog/:code1/filter/:filter" children={<Suspense fallback={<div>Загрузка....</div>} > <CatalogPage/></Suspense> }/>
                        <Route exact path="/catalog/:code1/:code2" children={<Suspense fallback={<div>Загрузка....</div>} > <CatalogPage/></Suspense> }/>
                        <Route exact path="/catalog/:code1/:code2/filter/:filter" children={<Suspense fallback={<div>Загрузка....</div>} > <CatalogPage/></Suspense> }/>

                        <Route exact path="/brands" children={<Suspense fallback={<div>Загрузка....</div>} > <BrandPage/></Suspense> }/>
                        <Route exact path="/brands/:code1" children={<Suspense fallback={<div>Загрузка....</div>} > <BrandPage/></Suspense> }/>

                        <Route exact path="/delivery" children={<Suspense fallback={<div>Загрузка....</div>} > <DeliveryPage/></Suspense> }/>
                        <Route exact path="/payment" children={<Suspense fallback={<div>Загрузка....</div>} > <PaymentPage/></Suspense> }/>
                        <Route exact path="/how-order" children={<Suspense fallback={<div>Загрузка....</div>} > <HowOrderPage/></Suspense> }/>
                        <Route exact path="/returnConditions" children={<Suspense fallback={<div>Загрузка....</div>} > <ReturnConditionsPage/></Suspense> }/>
                        <Route exact path="/policy" children={<Suspense fallback={<div>Загрузка....</div>} > <ReturnConditionsPage/></Suspense> }/>
                        <Route exact path="/loyalty" children={<Suspense fallback={<div>Загрузка....</div>} > <LoyaltyPage/></Suspense> }/>


                        <Route path="/card/:code" children={ <Suspense fallback={<div>Загрузка....</div>} > <CardPage/></Suspense>}/>

                        <Route path="/quiz" exact children={<QuizPage/>}/>

                        <Route path="/admin" exact children={<AdminPage/>}/>

                        <Route path="/admin/auth" exact children={ <AdminAuthPage/>}/>
                        <Route path="/admin/email-replay" exact children={ <AdminEmailReplayPage/>}/>
                        <Route path="/admin/quiz-report" exact children={ <QuizReport/>}/>
                        <Route path="/admin/user-log" exact children={ <AdminUserLogPage/>}/>

                        <Route exact path="*" children={ <Suspense fallback={<div>Загрузка....</div>} ><NotFoundPage/></Suspense> }/>
                    </Switch>
                    <FooterBottom/>
                    <FixMenuBottom/>
                </Router>
            </>
        );
    }
}